<!-- 预赛 -->
<template>
    <div class="stage-mod stage-pre-playing">
        <div class="stage-box stage-box--empty">
            <div class="stage-box__msg">
                <!-- {{preRes|time2text}}公布初赛成绩、晋级名单、获奖名单 -->
                <dl>
                    <dd>{{preBegin|time2text}} 至 {{preEnd|time2text}}</dd>
                    <dd>每天开放<span class="red">1</span>个初赛擂台</dd>
                    <dd v-if="finishCupNum > 0">你完成了<span class="red">{{finishCupNum}}</span>个擂台，最高平均得分<span class="red">{{maxAvgScore}}</span></dd>
                    <dd v-else>初赛已开始，赶快去参赛吧！</dd>
                </dl>
            </div>
            <van-button size="big" @click="play" block type="danger">{{buttonText}}</van-button>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex'
    export default {
        name: 'pre-playing',
        computed: {
            ...mapGetters(['cupType', 'isValidUser', 'nowTime', 'leftFor', 'preBegin', 'preEnd', 'preRes', 'finishCupNum',
                'allCupNum', 'isFinishPre', 'maxAvgScore'
            ]),
            buttonText() {
                const {
                    isValidUser,
                    finishCupNum,
                    allCupNum
                } = this
                if (isValidUser && finishCupNum > 0) {
                    return finishCupNum < allCupNum ? `继续比赛` :
                        `查看记录`
                }
                return '参加初赛'
            }
        },
        methods: {
            ...mapActions(['goPrePlay', 'goLogin']),
            play() {
                this.goPrePlay()
                // const {isValidUser} = this
                // if(isValidUser > 0) {
                //     this.goPrePlay()
                // } else {
                //     this.$dialog.alert({
                //         title: '参赛提醒',
                //         message: '<div class="ta_left">尊敬的用户您好！<br>为保证您的比赛成绩留存及奖项核实发放，<span class="blue">验证手机号即可参与大赛</span>。</div>',
                //         // cancelButtonText: '取消',
                //         confirmButtonText: '验证手机号'
                //     }).then(() => {
                //         this.goLogin()
                //         // on confirm
                //     }).catch(() => {
                //         // on cancel
                //     });
                // }
            }
        }
    }

</script>
